module.exports = __webpack_public_path__ + "img/right6.f6be6e6e.png";